export default {
      id: "FunctionUpperLimbRight-usage",
      viewBox: "0 0 54 54",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#FunctionUpperLimbRight",
      toString: function () {
        return this.url;
      }
    }